<template>
  <div class="app-banner">
    <div class="title">디버 앱을 다운받고 모바일에서도 편리하게 주문해요</div>
    <div class="logo-wrap" v-if="userAgent === 'web'">
      <img @click="openGoogle" src="@/assets/img/Badge_google.png" />
      <img @click="openApple" src="@/assets/img/Badge_apple.png" />
    </div>
    <div class="logo-wrap mobile" v-else>
      <img
        v-if="userAgent === 'android'"
        @click="openGoogle"
        src="@/assets/img/Badge_google.png"
      />
      <img
        v-if="userAgent === 'ios'"
        @click="openApple"
        src="@/assets/img/Badge_apple.png"
      />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      userAgent: "",
      isMobile: null
    };
  },
  created() {
    //userAgent 확인
    const checkUserAgent = navigator.userAgent.toLowerCase();

    //모바일 확인
    this.isMobile = /iphone|ipad|ipod|android/i.test(checkUserAgent);

    if (this.isMobile) {
      //mobile
      if (checkUserAgent.indexOf("android") > -1) {
        return (this.userAgent = "android");
      } else if (
        checkUserAgent.indexOf("iphone") > -1 ||
        checkUserAgent.indexOf("ipad") > -1
      ) {
        return (this.userAgent = "ios");
      }
    } else {
      //pc
      return (this.userAgent = "web");
    }
  },
  methods: {
    openGoogle() {
      window.open(
        "https://play.google.com/store/apps/details?id=com.dverrnclient"
      );
    },
    openApple() {
      window.open(
        "https://apps.apple.com/kr/app/%EB%94%94%EB%B2%84/id1641061892"
      );
    }
  }
};
</script>
<style scoped>
.app-banner {
  background-color: var(--gray-100);
  display: flex;
  box-sizing: border-box;
  position: relative;
  height: 80px;
  padding: 12px 20px;
  align-items: center;

  flex-direction: column;
  justify-content: space-between;
}

.logo-wrap {
  display: flex;
  gap: 12px;
}

.logo-wrap.mobile {
  display: flex;
}

.title {
  font-size: 14px;
  font-weight: 22px;
}

img {
  max-height: 32px;
  width: 100%;
  max-width: 124px;
  cursor: pointer;
}

@media (min-width: 1024px) {
  .app-banner {
    flex-direction: row;
    justify-content: center;
    gap: 40px;
    padding: 0px 0px;
  }

  .title {
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
    color: var(--gray-700);
  }

  img {
    max-height: 40px;
  }
}
</style>
